import { BaseMany, BaseOne, Route } from '@cnx-saas/common';
import { ShipmentAssignment } from './ShipmentAssignment';
import { ShipmentDriver } from './ShipmentDriver';
import { ShipmentEventLog } from './ShipmentEventLog';
import { ShipmentIncident } from './ShipmentIncident';
import { AllocationWidgetType, ShipmentStatus } from './ShipmentStatus';
import { ShipmentStop } from './ShipmentStop';
import { ShipmentTransportRequirements } from './ShipmentTransportRequirements';
import { ShipmentVehicle } from './ShipmentVehicle';

export class Shipment extends BaseOne {
  assignment?: ShipmentAssignment;
  requests?: ShipmentAssignment[];
  driver?: ShipmentDriver;
  eventLog?: ShipmentEventLog[];
  transportOrderdocuments?: string[];
  flagged: boolean;
  status: ShipmentStatus;
  stops: ShipmentStop[];
  tenantId: string;
  referenceId?: string;
  transportRequirements: ShipmentTransportRequirements;
  incidents: ShipmentIncident[];
  distance?: number;
  vehicle?: ShipmentVehicle;
  route: Route;
  enRoute?: Route;
  anonymousLink?: string;
  transportAllocationId?: string;
  cargoboardId?: string;
  applicationDeadline?: Date;
}

export class ShipmentStatusCount {
  status: AllocationWidgetType;
  count: number;
}

export class Shipments extends BaseMany<Shipment> {}
